import { OnDestroy } from '@angular/core';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe.components/common/modal/modal.indra.service';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { takeWhile } from 'rxjs/operators';


@Component({
	selector: 'app-confirm-modal',
	templateUrl: './confirm-modal.indra.component.html',
	styleUrls: ['./confirm-modal.component.scss']
})
export class INDRAConfirmModalComponent extends AbstractModalContentComponent implements OnInit, OnDestroy {
	@ViewChild('modalBodyDiv') modalBodyDiv: ElementRef;
	title$: Observable<string> = this.store.select(fromStore.getConfirmModalTitle);
	bodyMsg$: Observable<string> = this.store.select(fromStore.getConfirmModalBodyMsg);
	okLabel$: Observable<string> = this.store.select(fromStore.getConfirmModalOKLabel);
	cancelLabel$: Observable<string> = this.store.select(fromStore.getConfirmModalCancelLabel);
	//isAccent when true confirm button is red, if false uses the primary color
	isAccent$: Observable<boolean> = this.store.select(fromStore.getConfirmModalIsAccent);
	isAlive: boolean = true;
	isChecked: boolean;


	constructor(
		private store: Store<fromStore.State>,
		protected modalService: ModalService, private router: Router) {
		super(modalService);
		this.TYPE = 'dialog';
	}

	ngOnInit() {
		this.loadHtml();
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	closeModal() {
		this.modalService.close();
	}

	cancel() {
		this.store.dispatch(new ConfirmModalActions.PutConfirm('cancel'));
		this.closeModal();
	}

	confirm() {
		this.store.dispatch(new ConfirmModalActions.PutConfirm('ok'));
		this.closeModal();
		//this.router.navigate(['/booking']);
	}

	async loadHtml() {
		this.bodyMsg$.pipe(takeWhile(() => this.isAlive)).subscribe(data => {
			this.modalBodyDiv.nativeElement.innerHTML = data;
		});
	}

}
